const enterpriseBackupInformation = r => require.ensure([], () => r(require('@/page/enterpriseBackupInformation/enterpriseBackupInformation')), 'enterpriseBackupInformation');
const enterpriseBackupOutsideProjectsList = r => require.ensure([], () => r(require('@/page/enterpriseBackupInformation/enterpriseBackupOutsideProjectsList/enterpriseBackupOutsideProjectsList')), 'enterpriseBackupOutsideProjectsList');
const enterpriseBackupInformationDetails = r => require.ensure([], () => r(require('@/page/enterpriseBackupInformation/enterpriseBackupInformationDetails/enterpriseBackupInformationDetails')), 'enterpriseBackupInformationDetails');
const outsideProjectsSummaryDetails = r => require.ensure([], () => r(require('@/page/enterpriseBackupInformation/outsideProjectsSummaryDetails/outsideProjectsSummaryDetails')), 'outsideProjectsSummaryDetails');
const enterpriseManageProjectAudit = r => require.ensure([], () => r(require('@/page/enterpriseBackupInformation/enterpriseManageProjectAudit/enterpriseManageProjectAudit')), 'enterpriseManageProjectAudit');

const enterpriseBackupInformationRouter = {
    path: '',
    name: '企业在管项目',
    component: enterpriseBackupInformation,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
        keepAlive:true,
    },
    children: [
        {
            path: '/enterpriseManageProjectAudit',
            component: enterpriseManageProjectAudit,
            name: '企业在管项目审核',
            meta: {
                right: ['企业在管项目审核'],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/enterpriseBackupOutsideProjectsList',
            component: enterpriseBackupOutsideProjectsList,
            name: '企业在管项目列表',
            meta: {
                right: ['企业在管项目列表'],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/enterpriseBackupInformationDetails',
            component: enterpriseBackupInformationDetails,
            name: '项目详情',
            meta: {
                right: ['项目详情'],
                isShowMenu: false,
                keepAlive: false,
            },
        },
        {
            path: '/outsideProjectsSummaryDetails',
            component: outsideProjectsSummaryDetails,
            name: '项目详情',
            meta: {
                right: ['项目详情'],
                isShowMenu: false,
                keepAlive: false,
            },
        },
    ]
};
export default enterpriseBackupInformationRouter;
